import { useEffect, useState } from "react";
import { Loader2, Inbox, Phone } from "lucide-react";
import { toast } from "sonner";
import { api, WHATSAPP_URL, formatApiError } from "@/lib/api";
import { PageHeader, StatusSelect } from "@/components/admin/ui";

const STATUSES = ["Novo", "Contatado", "Convertido"];

export default function LeadsPage() {
  const [leads, setLeads] = useState(null);

  const load = () => api.get("/leads").then((r) => setLeads(r.data)).catch(() => setLeads([]));
  useEffect(() => {
    load();
  }, []);

  const setStatus = async (lead, status) => {
    try {
      await api.patch(`/leads/${lead.id}`, { status });
      toast.success(`Lead marcado como "${status}"`);
      load();
    } catch (err) {
      toast.error(formatApiError(err));
    }
  };

  if (!leads) {
    return (
      <div className="flex h-64 items-center justify-center">
        <Loader2 size={28} className="animate-spin text-[#FFB800]" />
      </div>
    );
  }

  return (
    <div data-testid="leads-page">
      <PageHeader title="Leads do Site" sub="Pedidos enviados pelo formulário da landing page" testId="leads-header" />
      {leads.length === 0 ? (
        <div className="flex flex-col items-center gap-4 rounded-2xl border border-dashed border-white/10 bg-[#11141A] py-20 text-center" data-testid="leads-empty">
          <Inbox size={40} className="text-zinc-600" />
          <p className="text-sm text-zinc-500">Nenhum lead ainda. Os pedidos do formulário do site aparecem aqui.</p>
        </div>
      ) : (
        <div className="grid gap-4 lg:grid-cols-2" data-testid="leads-list">
          {leads.map((lead, i) => (
            <div key={lead.id} className="rounded-2xl border border-white/5 bg-[#11141A] p-6" data-testid={`lead-card-${i}`}>
              <div className="flex items-start justify-between gap-3">
                <div>
                  <p className="font-display text-lg font-bold text-white">{lead.name}</p>
                  <a href={`tel:${lead.phone}`} className="mt-0.5 flex items-center gap-1.5 text-sm text-zinc-400 hover:text-[#FFB800]">
                    <Phone size={13} /> {lead.phone}
                  </a>
                </div>
                <StatusSelect
                  value={lead.status}
                  options={STATUSES}
                  onChange={(s) => setStatus(lead, s)}
                  testId={`lead-status-select-${i}`}
                />
              </div>
              <div className="mt-4 rounded-xl bg-[#0A0B0D] px-4 py-3">
                <p className="text-xs font-bold uppercase tracking-wider text-[#FFB800]">{lead.service}</p>
                {lead.message && <p className="mt-1 text-sm text-zinc-400">{lead.message}</p>}
              </div>
              <div className="mt-4 flex items-center justify-between">
                <p className="text-[11px] text-zinc-600">
                  {new Date(lead.created_at).toLocaleString("pt-BR")}
                </p>
                <a
                  href={`https://wa.me/55${lead.phone.replace(/\D/g, "")}`}
                  target="_blank"
                  rel="noreferrer"
                  data-testid={`lead-whatsapp-${i}`}
                  className="rounded-full bg-[#25D366]/15 px-4 py-1.5 text-xs font-bold text-[#25D366] transition-colors hover:bg-[#25D366]/25"
                >
                  Chamar no WhatsApp
                </a>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
